import React from 'react';
import {Link, useLocation} from 'react-router-dom';

import {BiHomeHeart} from 'react-icons/bi'
import {RiUserHeartLine, RiChatSmile3Line} from 'react-icons/ri'
import {SiCodeproject} from 'react-icons/si'
import {GiPencilBrush} from 'react-icons/gi'

import { Slide } from 'react-animated-components'

import './navbar.css'

export default function Navbar() {

  const path = useLocation().pathname;

  return (
    <Slide
      ref={{
        current: '[Circular]'
      }}
      direction="down"
      fade
      onActive={function noRefCheck(){}}
      onComplete={function noRefCheck(){}}
      wipe
    >
      <div className='navbarContainer'>
        <div className='navbar'>
          <ul>
            <li className={`list ${path==='/'?'active':''}`}>
              <Link to="/">
                <span className='icon'><BiHomeHeart/></span>
                <span className='text'>Home</span>
              </Link>
            </li>
            <li className={`list ${path==='/about'?'active':''}`}>
              <Link to="/about">
                <span className='icon'><RiUserHeartLine/></span>
                <span className='text'>About</span>
              </Link>
            </li>
            <li className={`list ${path==='/projects'?'active':''}`}>
              <Link to="/projects">
                <span className='icon'><SiCodeproject/></span>
                <span className='text'>Projects</span>
              </Link>
            </li>
            <li className={`list ${path==='/hobbies'?'active':''}`}>
              <Link to="/hobbies">
                <span className='icon'><GiPencilBrush/></span>
                <span className='text'>Hobbies</span>
              </Link>
            </li>
            <li className={`list ${path==='/contact'?'active':''}`}>
              <Link to="/contact">
                <span className='icon'><RiChatSmile3Line/></span>
                <span className='text'>Contact</span>
              </Link>
            </li>
            <div className='indicator'></div>
          </ul>
        </div>
      </div>
    </Slide>
  )
}
